<template>
    <div>
        <img
            alt="Image"
            class="hero"
            src="../assets/OFX Hero Section copy.png"
        />
        <div class="container" v-show="status === 'LOADING'">
            <div class="container-body">
                <img
                    class="apiLoader"
                    src="../assets/loading.png"
                    alt="LOADING"
                />
                <h5 class="about">LOADING</h5>
            </div>
        </div>
        <div class="container" v-show="status === 'DOCUSIGN_LEVEL1_SIGNED'">
            <div class="row">
                <div class="col-sm">
                    <h5 class="text-left about">
                        Thanks for providing your information. Your profile is
                        under review.
                    </h5>
                    <hr />
                    <p class="text-left body">
                        Your profile has been submitted and will be reviewed by
                        our team, You will be notified if any additional
                        information is needed. <br /><br />
                        <strong
                            >If you have any questions please reach out to
                            <a style="color: #019382"
                                >fdxsupport@financialdataexchange.org</a
                            >
                        </strong>
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-show="status === 'DOCUSIGN_COMPLETED'">
            <div class="row">
                <div class="container-body col-sm">
                    <hr />
                    <p class="text-left body">
                        The Agreement is signed and completed by both the parties. All the stakeholders will receive a copy of the agreement and the documents. Please check your email for more details.<br /><br />
                        Thank you,<br />
                        FDX Team<br />
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    // eslint-disable-next-line
    name: "WelcomeReview",
    methods: {
        ...mapActions(["updateDocusignProgress"]),
    },
    created() {
        if (JSON.parse(this.$store.state.user)) {
            let orgProgressList = JSON.parse(this.$store.state.user)
                .organizationRequest.organizationProgressList;
                this.status =
                    orgProgressList[orgProgressList.length - 1].progressType;
        }
        if (this.$route.query.envelopeid && this.$route.query.email) {
            let req = {
                envelopeid: this.$route.query.envelopeid,
                email: this.$route.query.email,
            };
            this.updateDocusignProgress(req);
        }
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === "setUser" && mutation.payload !== null) {
                let orgProgressList = JSON.parse(this.$store.state.user)
                    .organizationRequest.organizationProgressList;
                    this.status =
                        orgProgressList[orgProgressList.length - 1].progressType;
            }
        });
    },
    data() {
        return {
            status: "LOADING",
        };
    },
};
</script>

<style>
.hero {
    width: -webkit-fill-available;
    height: 400px;
}
.about {
    font-weight: 500;
    font-size: 34px;
    line-height: 41px;
    color: #1978a0;
    padding-top: 30px;
}
.container-body {
    box-sizing: border-box;
    max-width: 1123px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
    padding-top: 3%;
    padding-bottom: 12%;
}
.apiLoader {
    width: 10%;
}
.contact-info {
    margin-left: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
hr {
    border: 1px solid #d8d8d8;
}
p {
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
.heading-level {
    font-size: 18px;
    line-height: 24px;
}
.target_links {
    color: #019382;
    text-decoration: underline;
}
.body {
    padding-bottom: 10%;
}
@media (max-width: 600px) {

    .hero {
        height: 200px !important;
    }

    .about {
        font-weight: 400  !important;
        font-size: 28px  !important;
        line-height: 31px  !important;
        padding-top: 20px  !important;
    }

}
@media (max-width: 425px) {

    .hero {
        height: 120px !important;
    }
    .about {
        font-weight: 500 !important;
        font-size: 18px !important;
        line-height: 25px !important;
        padding-top: 15px !important;
    }
    p {
        font-size: 14px !important;
    }
}
</style>
